module.exports = "mutation CreateIssue($issue:CreateIssueInput!){createIssue(issue:$issue){success id}}"